export { useParticipationCertificates } from './hooks/useParticipationCertificates';
export { default as Diplomas } from './LazyDiplomas';
export type {
  DiplomasLocaleKeys,
  DiplomasProps,
  PropJoinDownload,
} from './types';
